import React from 'react'

import ArticlesOverviewWrapper from '../../../react4xp/components/ArticlesOverviewWrapper'

function ArticlesOverviewPart({title, tags, endpoint, startValues, strings}) {
	return (
		<ArticlesOverviewWrapper 
			title={title} 
			tags={tags} 
			endpoint={endpoint}
			startValues={startValues}
			strings={strings}
		/>
	)
}

export default (props) => <ArticlesOverviewPart {...props} />
